import React, { useEffect, useState } from "react";
import FilterListIcon from "@mui/icons-material/FilterList";
import { styled } from "@mui/system";
import { Box, Button, Popover, Toolbar } from "@mui/material";
import { Form, Formik } from "formik";
import InputField from "../../../../components/formFields/InputField";
import {
  setMemberName,
  setNaicCode,
  setMemberEmail
} from "../../../../store/slices/FilterSlice";
import { useDispatch, useSelector } from "react-redux";

const StyledPopover = styled(Popover)({
  "& .MuiPaper-root": {
    padding: "24px",
    height: "fit-content",
    width: "300px",
    flexDirection: "column",
    display: "flex",
    justifyContent: "space-between",
  },
});

const FieldContainer = styled(Box)({
  width: "252px",
  margin: "5px 0px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  "& .MuiFormLabel-root": {
    marginBottom: "9px",
  },
  "& .MuiInputBase-root": {
    minWidth: "100%",
    minHeight: "30px",
    border: "1px solid #b2b9dc",
    borderRadius: "4px",
    "& input": {
      paddingLeft: "10px",
      paddingRight: "10px",
      paddingBottom: "0px",
      paddingTop: "0px",
    },
  },
});

const StyledButton = styled(Button)(({ theme, isfull }) => ({
  backgroundColor: isfull ? theme.palette.primary.main : "",
  color: isfull ? theme.palette.info.contrastText : theme.palette.primary.main,
  svg: {
    color: isfull
      ? theme.palette.info.contrastText
      : theme.palette.primary.main,
  },
}));

export const TableFilter = (props) => {
  const { onApplyFilters, type, assessmentClassesFilter, isActiveFilter } =
    props;
  const { naicCode, memberName, memberEmail } =
    useSelector((state) => state.filter);

  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const onFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    return () => {
      onReset();
    };
  }, []);

  const onReset = (e) => {
    dispatch(setNaicCode(""));
    dispatch(setMemberName(""));
    dispatch(setMemberEmail(""));
    setAnchorEl(null);
    onApplyFilters({ naicCode: "", memberName: "", memberEmail: "" });
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleSubmit = (value) => {
    dispatch(setMemberEmail(value.memberEmail));
    dispatch(setNaicCode(value.naicCode));
    dispatch(setMemberName(value.memberName));
    onApplyFilters(value);
    setAnchorEl(null);
  };
  return (
    <Toolbar sx={{ minHeight: "0px !important" }}>
      <StyledButton
        onClick={onFilterClick}
        startIcon={<FilterListIcon />}
        variant="outlined"
        isfull={naicCode || memberName || memberEmail}
      >
        Filter
      </StyledButton>
      <StyledPopover
        id={"filter-popover"}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Formik
          initialValues={{
            naicCode,
            memberName,
            memberEmail,
          }}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {() => (
            <Form id={"filterForm"}>
              <FieldContainer>
                <InputField name={"naicCode"} label={"NAIC Code"} />
              </FieldContainer>
              <FieldContainer>
                <InputField
                  name={"memberName"}
                  label={type && type !== 'groups' ? "Insolvent Company" : "Member Name"}
                />
              </FieldContainer>
              <FieldContainer>
                <InputField name={"memberEmail"} label={"Email"} />
              </FieldContainer>
              <Box sx={{ display: "flex" }}>
                <StyledButton type="submit">Apply</StyledButton>
                <StyledButton onClick={onReset}>Reset</StyledButton>
              </Box>
            </Form>
          )}
        </Formik>
      </StyledPopover>
    </Toolbar>
  );
};
